import React from "react";
import { LecturersTable } from "../components/LecturersTable";
export const LecturersEvaluations = () => {
  return (
    <>
      <div className="section-title-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <div className="content">
                  <h2 className="fw-bold">Lecturers Evaluations</h2>
                  <p>
                    The table below lists all the lecturers and their evaluation
                    scores. This tool is made to help students find suitable
                    lecturers for their courses. There is zero intention to
                    disrespect or devalue lecturers or the work they do.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LecturersTable readOnly={true} />
    </>
  );
};
